import React from 'react';

const QuestionForm = ({ 
  question, 
  questionIndex, 
  totalQuestions, 
  formData, 
  updateFormData, 
  nextStep, 
  prevStep 
}) => {
  
  const handleTextChange = (e) => {
    updateFormData('text', e.target.value, questionIndex);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = [];
    const validFileNames = [];
    
    // Check file size (5MB limit per file)
    files.forEach(file => {
      if (file.size <= 5 * 1024 * 1024) { // 5MB in bytes
        // Create a new File object to ensure it's unique to this question
        const newFile = new File([file], file.name, { type: file.type });
        validFiles.push(newFile);
        validFileNames.push(file.name);
      } else {
        alert(`File "${file.name}" exceeds the 5MB size limit and will not be added.`);
      }
    });
    
    // Only use attachments for the current question
    const newAttachments = [...formData.answers[questionIndex].attachments, ...validFiles];
    updateFormData('attachments', newAttachments, questionIndex);
  };

  const removeAttachment = (index) => {
    const newAttachments = [...formData.answers[questionIndex].attachments];
    newAttachments.splice(index, 1);
    updateFormData('attachments', newAttachments, questionIndex);
  };

  return (
    <div className="question-form">
      <div className="progress-indicator">
        Question {questionIndex + 1} of {totalQuestions}
      </div>
      
      <h3>{question}</h3>
      
      <div className="form-group">
        <label htmlFor={`question-${questionIndex}`}>Your Answer:</label>
        <textarea
          id={`question-${questionIndex}`}
          value={formData.answers[questionIndex].text}
          onChange={handleTextChange}
          rows={10}
          placeholder="Enter your detailed response here..."
        />
      </div>
      
      <div className="form-group">
        <label>Attachments:</label>
        <input
          type="file"
          multiple
          onChange={handleFileChange}
          className="file-input"
        />
        <p className="help-text">You can attach multiple files of any type (up to 5MB per file)</p>
        
        {formData.answers[questionIndex].attachments.length > 0 && (
          <div className="attachments-list">
            <h4>Attached Files:</h4>
            <ul>
              {formData.answers[questionIndex].attachments.map((file, idx) => (
                <li key={idx}>
                  {file.name}
                  <button 
                    type="button" 
                    className="remove-button"
                    onClick={() => removeAttachment(idx)}
                  >
                    Remove
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      
      <div className="navigation-buttons">
        <button 
          type="button" 
          onClick={prevStep}
          className="prev-button"
        >
          Previous
        </button>
        <button 
          type="button" 
          onClick={nextStep}
          disabled={!formData.answers[questionIndex].text.trim()}
          className="next-button"
        >
          {questionIndex === totalQuestions - 1 ? 'Review Answers' : 'Next Question'}
        </button>
      </div>
    </div>
  );
};

export default QuestionForm;
